import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSeparatorField from 'modules/ui/editform/fields/EditFormSeparatorField';
import EditFormGroupFields from 'modules/ui/editform/subForm/EditFormGroupFields';
import { useParams, withRouter } from 'react-router';
import OptimizerType from '../dto/OptimizerType';
import OptimizerEditService from '../service/OptimizerEditService';
import ParticleSwarmOptimizerEditService from '../service/ParticleSwarmOptimizerEditService';
import ShgoOptimizerEditService from '../service/ShgoOptimizerEditService';
import QuadraticRestartOptimizerEditService from '../service/QuadraticRestartOptimizerEditService';
import RandomRestartOptimizerEditService from '../service/RandomRestartOptimizerEditService';
import DualAnnealingOptimizerEditService from '../service/DualAnnealingOptimizerEditService';
import BFGSOptimizerEditService from '../service/BFGSOptimizerEditService';
import LBFGSBOptimizerEditService from '../service/LBFGSBOptimizerEditService';
import DogLegOptimizerEditService from '../service/DogLegOptimizerEditService';
import CobylaOptimizerEditService from '../service/CobylaOptimizerEditService';
import OptimizerService from '../service/OptimizerService';
import DifferentialEvolutionOptimizerEditService from '../service/DifferentialEvolutionOptimizerEditService';
import DirectOptimizerEditService from '../service/DirectOptimizerEditService';
import NelderMeadOptimizerEditService from '../service/NelderMeadOptimizerEditService';
import PowellOptimizerEditService from '../service/PowellOptimizerEditService';
import ConjugateGradientOptimizerEditService from '../service/ConjugateGradientOptimizerEditService';
import NewtonCGOptimizerEditService from '../service/NewtonCGOptimizerEditService';
import TruncatedNewtonOptimizerEditService from '../service/TruncatedNewtonOptimizerEditService';
import TrustNCGOptimizerEditService from '../service/TrustNCGOptimizerEditService';
import NearExactTrustKrylovOptimizerEditService from '../service/NearExactTrustKrylovOptimizerEditService';
import NearExactTrustOptimizerEditService from '../service/NearExactTrustOptimizerEditService';
import BayesianOptimizerEditService from '../service/BayesianOptimizerEditService';
import SLSQPOptimizerEditService from '../service/SLSQPOptimizerEditService';
import GridDescentOptimizerEditService from '../service/GridDescentOptimizerEditService';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const blockClassName = 'rounded-8 border px-16 pt-10 pb-4 mb-16';
const blockTitleClassName = 'py-8';

const optimizerService = type => {
	if (type === 'RandomRestart') return RandomRestartOptimizerEditService;
	if (type === 'QuadraticRestart') return QuadraticRestartOptimizerEditService;
	if (type === 'ParticleSwarm') return ParticleSwarmOptimizerEditService;
	if (type === 'Shgo') return ShgoOptimizerEditService;
	if (type === 'DualAnnealing') return DualAnnealingOptimizerEditService;
	if (type === 'BFGS') return BFGSOptimizerEditService;
	if (type === 'LBFGSB') return LBFGSBOptimizerEditService;
	if (type === 'DogLeg') return DogLegOptimizerEditService;
	if (type === 'COBYLA') return CobylaOptimizerEditService;
	if (type === 'DifferentialEvolution') return DifferentialEvolutionOptimizerEditService;
	if (type === 'Direct') return DirectOptimizerEditService;
	if (type === 'NelderMead') return NelderMeadOptimizerEditService;
	if (type === 'Powell') return PowellOptimizerEditService;
	if (type === 'ConjugateGradient') return ConjugateGradientOptimizerEditService;
	if (type === 'NewtonCG') return NewtonCGOptimizerEditService;
	if (type === 'TruncatedNewton') return TruncatedNewtonOptimizerEditService;
	if (type === 'TrustNCG') return TrustNCGOptimizerEditService;
	if (type === 'NearExactTrustKrylov') return NearExactTrustKrylovOptimizerEditService;
	if (type === 'NearExactTrust') return NearExactTrustOptimizerEditService;
	if (type === 'BayesianOptimizer') return BayesianOptimizerEditService;
	if (type === 'SLSQP') return SLSQPOptimizerEditService;
	if (type === 'GridDescent') return GridDescentOptimizerEditService;
	return OptimizerEditService;
};

export const shgoMethod = [
	{ label: 'BFGS', value: 'BFGS' },
	{ label: 'L-BFGS-B', value: 'L-BFGS-B' },
	{ label: 'SLSQP', value: 'SLSQP' },
];
export const shgoSampling = [
	{ label: 'Halton', value: 'halton' },
	{ label: 'Sobol', value: 'sobol' },
	{ label: 'Simplicial', value: 'simplicial' },
];

export const differentialEvolutionOptimizerStrategy = [
	{ label: 'best1bin', value: 'best1bin' },
	{ label: 'best1exp', value: 'best1exp' },
	{ label: 'rand1bin', value: 'rand1bin' },
	{ label: 'rand1exp', value: 'rand1exp' },
	{ label: 'rand2bin', value: 'rand2bin' },
	{ label: 'rand2exp', value: 'rand2exp' },
	{ label: 'randtobest1bin', value: 'randtobest1bin' },
	{ label: 'randtobest1exp', value: 'randtobest1exp' },
	{ label: 'currenttobest1bin', value: 'currenttobest1bin' },
	{ label: 'currenttobest1exp', value: 'currenttobest1exp' },
	{ label: 'best2bin', value: 'best2bin' },
	{ label: 'best2exp', value: 'best2exp' }
]

export const differentialEvolutionOptimizerUpdating = [
	{ label: 'immediate', value: 'immediate' },
	{ label: 'deferred', value: 'deferred' }
]

export const differentialEvolutionPopulationInitialization = [
	{ label: 'latinhypercube', value: 'latinhypercube' },
	{ label: 'sobol', value: 'sobol' },
	{ label: 'halton', value: 'halton' },
	{ label: 'random', value: 'random' }
]

const config = data => {
	console.log(data);
	const form = {
		key: 'optimizerEditForm',
		topic: 'optimizer',
		service: optimizerService(data.type),
		defaultValue: () => optimizerService(data.type).createByType(data.type),
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'type',
					component: EditFormSelectField,
					type: 'enum',
					readOnly: true,
					items: Object.keys(OptimizerType).map(key => {
						return { label: OptimizerType[key], value: key };
					})
				},
				...(data.type === 'ParticleSwarm'
					? [
						{
							key: 'particleSwarmGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepParticleSwarm',
									text: 'Particle Swarm Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'maxIterationCount',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'particleCount',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'w',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'c1',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'c2',
									component: EditFormTextField,
									type: 'number'
								}
							]
						}
					]
					: []),
				...(data.type === 'Shgo'
					? [
						{
							key: 'shgoGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepShgo',
									text: 'Shgo Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'iters',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'n',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'method',
									component: EditFormSelectField,
									type: 'enum',
									items: shgoMethod
								},
								{
									key: 'samplingMethod',
									component: EditFormSelectField,
									type: 'enum',
									items: shgoSampling
								},
								{
									key: 'workers',
									component: EditFormTextField,
									type: 'number'
								}
							]
						}
					]
					: []),
				...(data.type === 'DualAnnealing'
					? [
						{
							key: 'dualAnnealingGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepDualAnnealing',
									text: 'Dual Annealing Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'maxiter',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'initialTemp',
									component: EditFormTextField,
									type: 'number',
									min: 0.01
								},
								{
									key: 'restartTempRatio',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'visit',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'accept',
									component: EditFormTextField,
									type: 'number'
								}
							]
						}
					]
					: []),
				...(data.type === 'DogLeg'
					? [
						{
							key: 'dogLegGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepDogLeg',
									text: 'Dog Leg Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'initialTrustRadius',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'maxTrustRadius',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'tol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'eta',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'gtol',
									component: EditFormTextField,
									type: 'number'
								}
							]
						}
					] : []),
				...(data.type === 'COBYLA'
					? [
						{
							key: 'cobylaGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepCobyla',
									text: 'Cobyla Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'rhobeg',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'maxiter',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'tol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'catol',
									component: EditFormTextField,
									type: 'number'
								}
							]
						}
					]
					: []),
				...(data.type === 'BFGS'
					? [
						{
							key: 'bfgsGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepBFGS',
									text: 'BFGS Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'maxiter',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'gtol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'norm',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'xrtol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'c1',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'c2',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'eps',
									component: EditFormTextField,
									type: 'number'
								}
							]
						}
					]
					: []),
				...(data.type === 'LBFGSB'
					? [
						{
							key: 'lbfgsbGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepLBFGSB',
									text: 'LBFGSB Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'maxiter',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'maxcor',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'ftol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'gtol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'eps',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'maxfun',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'maxls',
									component: EditFormTextField,
									type: 'number'
								}
							]
						}
					]
					: []),
				...(data.type === 'RandomRestart'
					? [
						{
							key: 'randomRestartGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepRandomRestart',
									text: 'Random Restart Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'maxEpoch',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'localOptimizer',
									component: EditFormSelectField,
									items: () => OptimizerService.getListSelection()
								}
							]
						}
					]
					: []),
				...(data.type === 'QuadraticRestart'
					? [
						{
							key: 'quadraticRestartGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepQuadraticRestart',
									text: 'Quadratic Restart Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'maxEpoch',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'localOptimizer',
									component: EditFormSelectField,
									items: () => OptimizerService.getListSelection()
								},
								{
									key: 'modelOptimizer',
									component: EditFormSelectField,
									items: () => OptimizerService.getListSelection()
								}
							]
						}
					]
					: []),
				...(data.type === 'DifferentialEvolution'
					? [
						{
							key: 'differentialEvolutionGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepDifferentialEvolution',
									text: 'Differential Evolution Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'maxiter',
									component: EditFormTextField,
									type: 'number',
								},
								{
									key: 'strategy',
									component: EditFormSelectField,
									type: 'enum',
									items: differentialEvolutionOptimizerStrategy,
								},
								{
									key: 'popsize',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'mutation',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'recombination',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'updating',
									component: EditFormSelectField,
									type: 'enum',
									items: differentialEvolutionOptimizerUpdating,
								},
								{
									key: 'init',
									component: EditFormSelectField,
									type: 'enum',
									items: differentialEvolutionPopulationInitialization,
								}
							]
						}
					]
					: []),
				...(data.type === 'Direct'
					? [
						{
							key: 'directGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepDirect',
									text: 'Direct Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'iters',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'eps',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'fMinRtol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'locallyBiased',
									component: EditFormSelectField,
									type: 'boolean'
								},
								{
									key: 'volTol',
									component: EditFormTextField,
									type: 'number'
								}
							]
						}
					]
					: []),
				...(data.type === 'NelderMead'
					? [
						{
							key: 'nelderMeadGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepNelderMead',
									text: 'Nelder-Mead Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'maxiter',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'xatol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'tol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'fatol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'adaptive',
									component: EditFormSelectField,
									type: 'boolean'
								}
							]
						}
					]
					: []),
				...(data.type === 'Powell'
					? [
						{
							key: 'powellGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepPowell',
									text: 'Powell Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'maxiter',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'xtol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'ftol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'tol',
									component: EditFormTextField,
									type: 'number'
								}
							]
						}
					]
					: []),
				...(data.type === 'ConjugateGradient'
					? [
						{
							key: 'conjugateGradientGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepConjugateGradient',
									text: 'Conjugate Gradient Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'maxiter',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'gtol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'norm',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'c1',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'c2',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'eps',
									component: EditFormTextField,
									type: 'number'
								}
							]
						}
					]
					: []),
				...(data.type === 'NewtonCG'
					? [
						{
							key: 'newtonCGGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepNewtonCG',
									text: 'NewtonCG Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'maxiter',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'xtol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'tol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'c1',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'c2',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'eps',
									component: EditFormTextField,
									type: 'number'
								}
							]
						}
					]
					: []),
				...(data.type === 'TruncatedNewton'
					? [
						{
							key: 'truncatedNewtonGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepTruncatedNewton',
									text: 'Truncated Newton Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'offset',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'tol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'eta',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'stepmx',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'accuracy',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'minfev',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'ftol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'xtol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'gtol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'rescale',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'maxfun',
									component: EditFormTextField,
									type: 'number'
								},
							]
						}
					]
					: []),
				...(data.type === 'TrustNCG'
					? [
						{
							key: 'trustNCGGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepTrustNCG',
									text: 'TrustNCG Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'maxiter',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'gtol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'xtol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'tol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'barrier_tol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'initial_tr_radius',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'initial_constr_penalty',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'initial_barrier_parameter',
									component: EditFormTextField,
									type: 'number'
								}
							]
						}
					]
					: []),
				...(data.type === 'NearExactTrustKrylov'
					? [
						{
							key: 'nearExactTrustKrylovGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepNearExactTrustKrylov',
									text: 'NearExactTrustKrylov Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'inexact',
									component: EditFormSelectField,
									type: 'boolean'
								},
								{
									key: 'tol',
									component: EditFormTextField,
									type: 'number'
								},
							]
						}
					]
					: []),
				...(data.type === 'NearExactTrust'
					? [
						{
							key: 'nearExactTrustGroup',
							text: 'NearExactTrust Options',
							component: EditFormSeparatorField,
							className: blockTitleClassName,
							isControlledInput: false
						},
						{
							key: 'initialTrustRadius',
							component: EditFormTextField,
							type: 'number'
						},
						{
							key: 'maxTrustRadius',
							component: EditFormTextField,
							type: 'number'
						},
						{
							key: 'tol',
							component: EditFormTextField,
							type: 'number'
						},
						{
							key: 'eta',
							component: EditFormTextField,
							type: 'number'
						},
						{
							key: 'gtol',
							component: EditFormTextField,
							type: 'number'
						},
					]
					: []),
				...(data.type === 'BayesianOptimizer'
					? [
						{
							key: 'bayesianOptimizerGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepBayesianOptimizer',
									text: 'Bayesian Optimizer Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'initialPoint',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'iterations',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'verbose',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'randomState',
									component: EditFormTextField,
									type: 'number'
								},
							]
						}
					]
					: []),
				...(data.type === 'SLSQP'
					? [
						{
							key: 'sLSQPGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepSLSQP',
									text: 'SLSQP Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'maxiter',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'eps',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'ftol',
									component: EditFormTextField,
									type: 'number'
								},
								{
									key: 'tol',
									component: EditFormTextField,
									type: 'number'
								}
							]
						}
					]
					: []),
				...(data.type === 'GridDescent'
					? [
						{
							key: 'gridDescentGroup',
							component: EditFormGroupFields,
							className: blockClassName,
							fields: [
								{
									key: 'sepGridDescent',
									text: 'Grid Descent Options',
									component: EditFormSeparatorField,
									className: blockTitleClassName,
									isControlledInput: false
								},
								{
									key: 'epsilon',
									component: EditFormTextField,
									type: 'number'
								},
							]
						}
					]
					: []),
			];
			return fields;
		}
	};

	return form;
};

function OptimizerEditForm() {
	const { id, type, tabKey } = useParams();

	const myConfig = config({ id, type });
	console.log(myConfig);

	return <EditFormPage config={myConfig} />;
}

export default withRouter(OptimizerEditForm);


// import EditFormPage from 'modules/ui/editform/EditFormPage';
// import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
// import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
// import { useParams, withRouter } from 'react-router';
// import OptimizerType from '../dto/OptimizerType';
// import OptimizerEditService from '../service/OptimizerEditService';
// import ParticleSwarmOptimizerEditService from '../service/ParticleSwarmOptimizerEditService';
// import ShgoOptimizerEditService from '../service/ShgoOptimizerEditService';
// import RestartOptimizerEditService from '../service/RestartOptimizerEditService';
// import DualAnnealingOptimizerEditService from '../service/DualAnnealingOptimizerEditService';

// const optimizerService = type => {
// 	// if (type === 'RandomRestart' || type === 'QuadraticRestart') return RestartOptimizerEditService;
// 	// if (type === 'ParticleSwarm') return ParticleSwarmOptimizerEditService;
// 	// if (type === 'Shgo') return ShgoOptimizerEditService;
// 	// if (type === 'DualAnnealing') return DualAnnealingOptimizerEditService;
// 	return OptimizerEditService;
// };

// export const shgoMethod = [
// 	{ label: 'BFGS', value: 'BFGS' },
// 	{ label: 'L-BFGS-B', value: 'L-BFGS-B' },
// 	{ label: 'SLSQP', value: 'SLSQP' },
// ];
// export const shgoSampling = [
// 	{ label: 'Halton', value: 'halton' },
// 	{ label: 'Sobol', value: 'sobol' },
// 	{ label: 'Simplicial', value: 'simplicial' },
// ];

// const config = data => {
// 	console.log(data);
// 	const form = {
// 		key: 'optimizerEditForm',
// 		topic: 'optimizer',
// 		service: optimizerService(data.type),
// 		defaultValue: () => optimizerService(data.type).createByType(data.type),
// 		fields: initData => {
// 			const fields = [
// 				{
// 					key: 'name',
// 					component: EditFormTextField,
// 					required: true,
// 					readOnly: data.id !== 'new'
// 				},
// 				{
// 					key: 'type',
// 					component: EditFormSelectField,
// 					type: 'enum',
// 					readOnly: true,
// 					items: Object.keys(OptimizerType).map(key => {
// 						return { label: OptimizerType[key], value: key };
// 					})
// 				},
// 				...(data.type === 'ParticleSwarm'
// 					? [
// 							{
// 								key: 'maxIterationCount',
// 								component: EditFormTextField,
// 								type: 'number'
// 							},
// 							{
// 								key: 'particleCount',
// 								component: EditFormTextField,
// 								type: 'number'
// 							},
// 							{
// 								key: 'w',
// 								component: EditFormTextField,
// 								type: 'number'
// 							},
// 							{
// 								key: 'c1',
// 								component: EditFormTextField,
// 								type: 'number'
// 							},
// 							{
// 								key: 'c2',
// 								component: EditFormTextField,
// 								type: 'number'
// 							}
// 					  ]
// 					: []),
// 				...(data.type === 'Shgo'
// 					? [
// 							{
// 								key: 'iters',
// 								component: EditFormTextField,
// 								type: 'number'
// 							},
// 							{
// 								key: 'n',
// 								component: EditFormTextField,
// 								type: 'number'
// 							},
// 							{
// 								key: 'method',
// 								component: EditFormSelectField,
// 								type: 'enum',
// 								items: shgoMethod
// 							},
// 							{
// 								key: 'samplingMethod',
// 								component: EditFormSelectField,
// 								type: 'enum',
// 								items: shgoSampling
// 							},
// 							{
// 								key: 'workers',
// 								component: EditFormTextField,
// 								type: 'number'
// 							}
// 					  ]
// 					: []),
// 				...(data.type === 'DualAnnealing'
// 					? [
// 							{
// 								key: 'maxiter',
// 								component: EditFormTextField,
// 								type: 'number'
// 							},
// 							{
// 								key: 'initialTemp',
// 								component: EditFormTextField,
// 								type: 'number',
// 								min: 0.01
// 							},
// 							{
// 								key: 'restartTempRatio',
// 								component: EditFormTextField,
// 								type: 'number'
// 							},
// 							{
// 								key: 'visit',
// 								component: EditFormTextField,
// 								type: 'number'
// 							},
// 							{
// 								key: 'accept',
// 								component: EditFormTextField,
// 								type: 'number'
// 							}
// 					  ]
// 					: []),

// 				...(data.type === 'RandomRestart' || data.type === 'QuadraticRestart'
// 					? [
// 							{
// 								key: 'maxIterationCount',
// 								component: EditFormTextField,
// 								type: 'number'
// 							},
// 							{
// 								key: 'local_search_name',
// 								component: EditFormTextField
// 							}
// 					  ]
// 					: [])
// 			];
// 			return fields;
// 		}
// 	};

// 	return form;
// };

// function OptimizerEditForm() {
// 	const { id, type, tabKey } = useParams();

// 	const myConfig = config({ id, type });
// 	console.log(myConfig);

// 	return <EditFormPage config={myConfig} />;
// }

// export default withRouter(OptimizerEditForm);
